import { hits } from 'instantsearch.js/es/widgets'
import { replaceHighlightsRecursive, wptemplate } from '../../../helper-functions'

/**
 * Load the hits widget.
 *
 * @param {Element} mainContainer The main search container.
 * @returns {Array} The stats widgets.
 */
export default function hitsWidget( mainContainer ) {
  const widgets = []

  const hitsContainer = mainContainer.querySelector( '.js-instant-search-hits' )

  widgets.push(
    hits({
      container: hitsContainer,
      templates: {
        empty: data => {
          mainContainer.classList.add( 'instant-search--no-results' )
          return wptemplate( 'instantsearch-no-results' )( data )
        },
        item: data => {
          mainContainer.classList.remove( 'instant-search--no-results' )
          return wptemplate( 'instantsearch-hit' )( data )
        }
      },
      transformData: {
        item: hit => {
          hit._highlightResult = replaceHighlightsRecursive( hit._highlightResult )
          hit._snippetResult = replaceHighlightsRecursive( hit._snippetResult )

          return hit
        }
      },
      cssClasses: {
        item: hitsContainer.dataset.itemClass,
        list: hitsContainer.dataset.containerClass
      }
    })
  )

  return widgets
}
